module.exports = __webpack_public_path__ + "img/indextop.6f4d4a78.png";